export default __webpack_public_path__ + "static/media/menu-icon.4a292e6b.svg";